import React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { Translate, ICrudGetAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './tenant.reducer';
import { ITenant } from 'app/shared/model/tenant.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface ITenantDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export class TenantDetail extends React.Component<ITenantDetailProps> {
  componentDidMount() {
    this.props.getEntity(this.props.match.params.id);
  }

  render() {
    const { tenantEntity } = this.props;
    return (
      <Row>
        <Col md="8">
          <h2>
            <Translate contentKey="dealorGatewayApp.tenant.detail.title">Tenant</Translate> [<b>{tenantEntity.id}</b>]
          </h2>
          <dl className="jh-entity-details">
            <dt>
              <span id="name">
                <Translate contentKey="dealorGatewayApp.tenant.name">Name</Translate>
              </span>
            </dt>
            <dd>{tenantEntity.name}</dd>
            <dt>
              <span id="website">
                <Translate contentKey="dealorGatewayApp.tenant.website">Website</Translate>
              </span>
            </dt>
            <dd>{tenantEntity.website}</dd>
            <dt>
              <span id="createdDate">
                <Translate contentKey="dealorGatewayApp.tenant.createdDate">Created Date</Translate>
              </span>
            </dt>
            <dd>
              <TextFormat value={tenantEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <span id="lastModifiedDate">
                <Translate contentKey="dealorGatewayApp.tenant.lastModifiedDate">Last Modified Date</Translate>
              </span>
            </dt>
            <dd>
              <TextFormat value={tenantEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <span id="zoneId">
                <Translate contentKey="dealorGatewayApp.tenant.zoneId">ZoneId</Translate>
              </span>
            </dt>
            <dd>{tenantEntity.zoneId}</dd>
            <dt>
              <span id="status">
                <Translate contentKey="dealorGatewayApp.tenant.status">Status</Translate>
              </span>
            </dt>
            <dd>{tenantEntity.status}</dd>
            <dt>
              <span id="keepalive">
                <Translate contentKey="dealorGatewayApp.tenant.keepalive">Keepalive</Translate>
              </span>
            </dt>
            <dd>{tenantEntity.keepalive}</dd>
          </dl>
          <Button tag={Link} to="/entity/tenant" replace color="info">
            <FontAwesomeIcon icon="arrow-left" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.back">Back</Translate>
            </span>
          </Button>
          &nbsp;
          <Button tag={Link} to={`/entity/tenant/${tenantEntity.id}/edit`} replace color="primary">
            <FontAwesomeIcon icon="pencil-alt" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </span>
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ tenant }: IRootState) => ({
  tenantEntity: tenant.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TenantDetail);
